import axios from 'axios'
//var url = 'https://ticket.shimenpark.cn/vis/'
var url = 'https://hi.cxtrip.cc/vis/'
const http = axios.create({
  baseURL: url, // api 的 base_url
  timeout: 1000 * 60,
  withCredentials: true, // 表示跨域请求时是否需要使用凭证
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json"
  }
});
http.interceptors.request.use(
  (config) => {
    // config.metadata = {
    //   startTime: new Date(),
    // };
    // config.headers.lang = localStorage.getItem("lang") || 'fan';
    // if (config.cancelToken === undefined) {
    //     config.cancelToken = axios.defaultSource.token; // 给每个请求添加标识符
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
* 响应拦截
*/
http.interceptors.response.use(
  async (response) => {
    if (response.data.code === 0) {
      response.data.duration = response.duration;
      return response.data
    } else {
      return Promise.resolve(response.data);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
* 自定义错误处理函数
*/

/**
* 统一处理url
*/
function adornUrl(url) {
  return `${url}`;
}
const post = (url, params, config = {}) => {
  const defaultConfig = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
  const mergedConfig = Object.keys(config).length ? config : defaultConfig;
  params = Object.keys(config).length ? params : new URLSearchParams(params).toString();
  return new Promise((resolve, reject) => {
    http.post(adornUrl(url), params, mergedConfig)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
const get = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    http.get(adornUrl(url), {
      params: params,
      ...config,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export { post, get, http, axios };